
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ViewType, OrderServiceStage } from "@/types/orderServicer";
import { UserModule } from '@/store/modules/user';

import DialogImgLarge from '@/components/ImgLarge/index.vue';
import searchForm from "./components/StockSearch.vue";

import { getRecord, getRecordDetail, recordExport } from '@/api/stock';

import {
  checkPermissionCompany
} from '@/utils/permission';
import { Type } from '@/types/permissionType';

@Component({
  name: 'StockInout',
  components: {
    DialogImgLarge,
    searchForm
  }
})
export default class extends Vue {
  private formSearch:any = {
    orderdate: '',
    name: '',
    model: '',
    serial: '',
    specification: '',
    select: '',
    type: '',
    inout_type: '',
    staff: {},
    customer: '',
    ordernumber: ''
  }
  private pagination: any = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  };
  // private searchCheckedItem = false
  private itemData:any = {
    orderdate: { name: '日期', value: '1', checked: false },
    name: { name: '名称', value: '2', checked: true },
    model: { name: '型号', value: '3', checked: true },
    serial: { name: '编号', value: '4', checked: false },
    specification: { name: '规格', value: '5', checked: true },
    type: { name: '类型', value: '6', checked: true },
    staff: { name: '人员', value: '7', checked: false },
    customer: { name: '客户', value: '8', checked: false, hidden: true },
    ordernumber: { name: '单号', value: '9', checked: false }
  }
  private tableData:any = []
  private dialogDetailVisible = false
  // private showCustomerSearch = false
  private stockSearch = {}
  private stockData: any = {}

  created() {
    if (this.$route.query.data) {
      let pageData = JSON.parse(this.$route.query.data as string);
      this.stockData = pageData
      // this.formSearch.staff = {
      //   id: pageData.inout_user_id,
      //   name: pageData.inout_user_name
      // };
      // this.formSearch.name = pageData.stock_name;
      // this.formSearch.model = pageData.model_name;
      // this.formSearch.select = [pageData.type, 0];
      // this.formSearch.type = pageData.type;
      // this.formSearch.inout_type = 0;
      // this.formSearch.customer = pageData.customer_name;
    } else {
      this.getRecord();
    }
    // this.showCustomerSearch = checkPermissionCompany(UserModule.getCompanyId, Type.CUSTOMER_COMPANY);
    // if (this.showCustomerSearch) {
    //   this.itemData.customer.hidden = !this.showCustomerSearch;
    // }
  }
  private handlePageSizeChange(val:any) {
    this.pagination.pageSize = val;
    this.getRecord();
  }
  private handleCurrentChange(val:any) {
    this.pagination.currentPage = val;
    this.getRecord();
  }

  // private search() {
  //   this.pagination.currentPage = 1;
  //   this.getRecord();
  // }

  // private searchClean() {
  //   this.formSearch = {
  //     orderdate: '',
  //     name: '',
  //     model: '',
  //     serial: '',
  //     specification: '',
  //     select: '',
  //     type: '',
  //     inout_type: '',
  //     staff: {},
  //     customer: '',
  //     ordernumber: ''
  //   };
  //   this.pagination.pageSize = 1;
  //   this.getRecord();
  // }
  private stockSearchHandle(val: any) {
    this.stockSearch = val;
    if (val) {
      this.pagination.currentPage = 1;
      this.getRecord()
    }
  }
  private getRecord() {
    let pamars:any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      company_name: UserModule.getCompanyName,
      page: this.pagination.currentPage,
      size: this.pagination.pageSize,
      ...this.stockSearch
    };
    // pamars.user_id = UserModule.getUserId;
    // pamars.user_name = UserModule.getUserName;
    // pamars.company_id = UserModule.getCompanyId;
    // pamars.company_name = UserModule.getCompanyName;
    // pamars.page = this.pagination.currentPage;
    // pamars.size = this.pagination.pageSize;
    // // 日期
    // pamars.times = this.formSearch.orderdate ? this.formSearch.orderdate.toString().substring(0, 10) : '';
    // // 名称
    // pamars.stock_name = this.formSearch.name;
    // // 型号
    // pamars.model_name = this.formSearch.model;
    // // 编号
    // pamars.serial_number = this.formSearch.serial;
    // // 规格
    // pamars.specification = this.formSearch.specification;
    // // 类型
    // pamars.type = this.formSearch.type;
    // pamars.inout_type = this.formSearch.inout_type;
    // // 人员
    // pamars.inout_user_id = this.formSearch.staff.id;
    // pamars.inout_user_name = this.formSearch.staff.name;
    // // 客户
    // pamars.customer_name = this.formSearch.customer;
    // // 单号
    // pamars.order_num = this.formSearch.ordernumber;
    getRecord(pamars).then(res => {
      if (res.data) {
        this.pagination.total = res.data.count;
        this.tableData = res.data.list;
      } else {
        this.tableData = [];
      }
    }).catch((error) => {
      this.pagination.total = 0;
      this.tableData = [];
      let msg = error.msg;
    });
  }
  private recordExport() {
    let pamars:any = {  ...this.stockSearch};
    pamars.user_id = UserModule.getUserId;
    pamars.user_name = UserModule.getUserName;
    pamars.company_id = UserModule.getCompanyId;
    pamars.company_name = UserModule.getCompanyName;
    pamars.page = this.pagination.currentPage;
    pamars.size = this.pagination.pageSize;
    // pamars.inout_user_id = UserModule.getUserId,
    // pamars.stock_name = this.formSearch.name;
    // pamars.model_name = this.formSearch.model;
    // pamars.serial_number = this.formSearch.serial;
    // pamars.specification = this.formSearch.specification;
    // pamars.type = this.formSearch.type;
    // 搜索更新了，但是这个没有更新，参数待定，本地测试导出一直99%，测出问题再改吧
    recordExport(pamars).then(res => {
      this.$confirm('是否跳转下载页面？', '跳转', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let routeData = this.$router.resolve({
          path: '/ExportTask',
          query: {}
        });
        window.open(routeData.href);
      }).catch(() => {

      });
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  private detailHandle(val:any) {
    this.getRecordDetail(val.id);
  }
  private recordDetail={}
  private getRecordDetail(id:any) {
    let pamars:any = {};
    pamars.user_id = UserModule.getUserId;
    pamars.user_name = UserModule.getUserName;
    pamars.company_id = UserModule.getCompanyId;
    pamars.company_name = UserModule.getCompanyName;
    pamars.id = id;
    getRecordDetail(pamars).then(res => {
      if (res.data) {
        this.recordDetail = res.data;
        this.dialogDetailVisible = true;
      }
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  private handleRecordOrder(recordDetail:any){
    let routeData = this.$router.resolve({
      path: "/OrderServicer/todetail",
      query: {
        order_service_id: recordDetail.order_service_id,
        company_id:recordDetail.company_id,
        viewType: ViewType.ORDER_SERVICER_ALL+"",
        // showBJD: "1",
        // tabName: "schedule",
      },
    });

    console.log(routeData.href);
    window.open(routeData.href);
  }

  private large(val: [], index: number) {
    let enlargedData = {
      isShow: true,
      imgList: [val],
      initNum: index
    };
    this.$store.dispatch('toggleEnlarged', enlargedData);
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}

